import React from "react";
import { Pagination, numberToINR, PropertyThumbnail } from "./";
import { useNavigate, Link } from "react-router-dom";

import Multiselect from "multiselect-react-dropdown";
import axios from "../api/axios";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

const PropertyTagging = ({ enquiryItem }) => {
  const propertyInformationUrl = "/pif";
  const propertyLocationUrl = "/pifLocation";
  const tagPifUrl = "/enquiry/add/pif";
  const navigate = useNavigate();

  const state = useSelector((state) => state.UserReducer);

  const [pifLocationsSelectedData, setPifLocationsSelectedData] =
    React.useState([]);
  const [pifLocations, setPIFLocations] = React.useState([]);
  const [approvalStatus, setapprovalStatus] = React.useState("");
  const [areaUnits, setareaUnits] = React.useState(0);
  const [minPrice, setminPrice] = React.useState(0);
  const [maxPrice, setmaxPrice] = React.useState(9999999999999);
  const [facing, setfacing] = React.useState("");
  const [refreshPropertyData, setRefreshPropertyData] = React.useState(1);
  const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [recordsPerPage, setRecordsPerPage] = React.useState(20);
  const [propertyInformationData, setPropertyData] = React.useState([]);

  const changePageCallback = (targetPageIndex) => {
    setCurrentPageIndex(targetPageIndex);
  };
  const changeDisplayRecordCountCallback = (targetRecordsPerPage) => {
    setRecordsPerPage(targetRecordsPerPage);
    setTotalPages(
      Math.ceil(propertyInformationData?.length / targetRecordsPerPage),
    );
  };

  const filterProperties = () => {
    setRefreshPropertyData(0);
    setTotalRecords(0);
    const queryOptions = {
      location: "",
      propertyOption: enquiryItem.propertyOptionId._id,
      subPropertyOption: enquiryItem.subPropertyOptionId._id,
      approvalStatus: approvalStatus,
      areaUnits,
      minPrice,
      maxPrice,
      facing,
      pifLocations,
    };
    const taggedPifIds = [];
    enquiryItem.taggedPif.map((item) => {
      taggedPifIds.push(item._id);
    });
    try {
      axios
        .get(propertyInformationUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
          params: {
            queryOptions,
            skip: currentPageIndex * recordsPerPage,
            limit: recordsPerPage,
            taggedPif: taggedPifIds,
          },
        })
        .then((response) => {
          // if (response?.data?.property?.length >= 0) {
          setPropertyData(response.data.property);
          // setPropertyServerData(response.data.property);
          if (response.data.propertyInformationCount?.length > 0) {
            setTotalRecords(
              response.data.propertyInformationCount[0].propertyInformationCnt,
            );
            setTotalPages(
              Math.ceil(
                response.data.propertyInformationCount[0]
                  .propertyInformationCnt / recordsPerPage,
              ),
            );
          } else {
            setTotalRecords(0);
            setTotalPages(0);
          }
          setRefreshPropertyData(1);
          // }
        })
        .catch((err) => {
          toast.error("Something went wrong");
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const [propertyLocationsData, setPropertyLocationsData] = React.useState([]);
  const getPropertyLocations = () => {
    try {
      axios
        .get(propertyLocationUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.pifLocations?.length > 0) {
            setPropertyLocationsData(response.data.pifLocations);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const tagProperty = (pifId) => {
    try {
      axios
        .put(
          tagPifUrl + "/" + enquiryItem._id + "/" + pifId,
          JSON.stringify({}),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  React.useEffect(() => {
    getPropertyLocations();
    filterProperties();
  }, [recordsPerPage, currentPageIndex]);

  return (
    <div className='w-full mt-3 py-5 px-4 bg-gradient-to-b from-yellow-50 to-yellow-50 rounded-sm'>
      <div className='lg:flex lg:items-center justify-between'>
        <div className='flex-1 min-w-0 px-0 lg:px-0'>
          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
            Property Matching
          </h2>
        </div>
      </div>
      <div className='mt-2 sm:mt-1 grid grid-cols-12 gap-2'>
        <div className='col-span-6 sm:col-span-2'>
          <label htmlFor='pifLocation' className='block text-sm font-medium'>
            Location
          </label>
          <Multiselect
            className={`mt-0 focus:ring-0 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-xs`}
            options={propertyLocationsData}
            selectedValues={pifLocationsSelectedData}
            onSelect={(selectedList, selectedItem) => {
              selectedList.map((item) => {
                delete item["validflag"];
                delete item["createdAt"];
                delete item["updatedAt"];
              });
              setPifLocationsSelectedData(selectedList);
              const pifLocationIds = [];
              selectedList.map((item) => {
                pifLocationIds.push(item._id);
              });
              setPIFLocations(pifLocationIds);
            }}
            onRemove={(selectedList, removedItem) => {
              selectedList.map((item) => {
                delete item["validflag"];
                delete item["createdAt"];
                delete item["updatedAt"];
              });
              setPifLocationsSelectedData(selectedList);
              const pifLocationIds = [];
              selectedList.map((item) => {
                pifLocationIds.push(item._id);
              });
              setPIFLocations(pifLocationIds);
            }}
            displayValue='name'
            style={{
              chips: {
                background: "#dea302",
                borderRadius: "2pt",
              },
              multiselectContainer: {
                color: "#000",
              },
              inputField: {
                "font-size": "13px",
                padding: "3px 5px 3px 7px",
                width: "100%",
                border: "none",
                boxShadow: "none",
              },
              searchBox: {
                border: "solid 0.5px #777",
                "font-size": "5px",
                padding: "1px",
                background: "#fff",
              },
            }}
          />
        </div>
        <div className='col-span-6 sm:col-span-2'>
          <label
            htmlFor='approvalStatus'
            className={`block text-sm font-medium `}>
            Approval Status
          </label>
          <select
            id='approvalStatus'
            name='approvalStatus'
            onChange={(e) => {
              setapprovalStatus(e.target.value);
            }}
            defaultValue={approvalStatus}
            className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm`}>
            <option key='0' value=''>
              Select
            </option>
            <option value='Approved'>Approved</option>
            <option value='Unapproved'>Unapproved</option>
          </select>
        </div>
        <div className='col-span-6 sm:col-span-2'>
          <label htmlFor='areaUnits' className={`block text-sm font-medium `}>
            Area Units (cents)
          </label>
          <input
            type='text'
            name='areaUnits'
            id='areaUnits'
            onChange={(e) => {
              setareaUnits(
                !isNaN(e.target.value)
                  ? e.target.value === ""
                    ? 0
                    : Number(e.target.value)
                  : 0,
              );
            }}
            defaultValue={areaUnits !== 0 ? areaUnits : ""}
            placeholder='Area Units (in cents)'
            maxLength='20'
            className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-full shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm py-2.5'
          />
        </div>
        <div className='col-span-6 sm:col-span-2'>
          <label htmlFor='facing' className='block text-sm font-medium'>
            Facing
          </label>
          <select
            id='facing'
            name='facing'
            onChange={(e) => {
              setfacing(e.target.value);
            }}
            defaultValue={facing}
            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
            <option value=''>Select</option>
            <option value='North'>North</option>
            <option value='South'>South</option>
            <option value='West'>West</option>
            <option value='East'>East</option>
            <option value='North-East'>North-East</option>
            <option value='North-West'>North-West</option>
            <option value='South-East'>South-East</option>
            <option value='South-West'>South-West</option>
            <option value='North and South'>North and South</option>
            <option value='East and West'>East and West</option>
            <option value='Others'>Others</option>
          </select>
        </div>
        <div className='col-span-12 sm:col-span-2'>
          <label htmlFor='areaUnits' className={`block text-sm font-medium `}>
            Price
          </label>
          <div className='flex gap-x-2'>
            <input
              type='text'
              name='minPrice'
              id='minPrice'
              defaultValue={minPrice > 0 ? minPrice : ""}
              onChange={(e) => {
                setminPrice(
                  !isNaN(e.target.value)
                    ? e.target.value === ""
                      ? 0
                      : Number(e.target.value)
                    : 0,
                );
              }}
              placeholder='Minimum'
              maxLength='13'
              className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-6/12 shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm py-2.5'
            />
            <input
              type='text'
              name='maxPrice'
              id='maxPrice'
              defaultValue={maxPrice < 9999999999999 ? maxPrice : ""}
              onChange={(e) => {
                setmaxPrice(
                  !isNaN(e.target.value)
                    ? e.target.value === ""
                      ? 0
                      : Number(e.target.value)
                    : 0,
                );
              }}
              placeholder='Maximum'
              maxLength='13'
              className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-6/12 shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm py-2.5'
            />
          </div>
        </div>
        <div className='col-span-12 sm:col-span-2'>
          {refreshPropertyData !== 0 ? (
            <div className='flex gap-4'>
              <button
                className='w-full mt-5 justify-center px-3 py-2 border-transparent shadow-sm text-sm font-medium rounded-sm bg-yellow-2 hover:bg-yellow-dark duration-300'
                onClick={(e) => {
                  filterProperties();
                }}>
                Find Properties
              </button>
            </div>
          ) : (
            <button
              className='animate-bounce cursor-wait mt-2 w-full inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
              disabled={true}>
              Processing...
            </button>
          )}
        </div>
      </div>
      {propertyInformationData.length > 0 && (
        <div className='pt-4 grid grid-cols-10 gap-5'>
          {propertyInformationData.map((item) => (
            <div
              key={item._id}
              onClick={(e) => {
                navigate("/property/" + item._id);
              }}
              className='relative flex-col col-span-5 sm:col-span-2 pt-0 bg-yellow-50 hover:border-yellow-dark duration-300 cursor-default border-gray-50 shadow-sm hover:shadow-xl hover:shadow-yellow-3 opacity-90 hover:opacity-100 '>
              <div className='justify-center max-h-56 bg-yellow-dark overflow-hidden '>
                <PropertyThumbnail
                  key={item.blobName}
                  thumbnail={item.thumbnail}
                  isthumbnail={true}
                />
              </div>
              <div className='absolute bottom-0 left-0 bg-yellow-light bg-opacity-100 w-full duration-300'>
                <div className='flex flex-col'>
                  <div className=' px-4 py-2'>
                    <div className='flex justify-between'>
                      <span className='text-sm font-semibold text-gray-dark'>
                        Service #{item.serviceTicketId.serviceTicketID}
                      </span>
                    </div>
                    <div className='flex-col'>
                      <div className='-mt-1'>
                        <span className='pt-0 text-xs font-semibold text-gray-dark w-full leading-3'>
                          {numberToINR(item.price)}
                        </span>
                      </div>
                      <div className='mt-1'>
                        <p className='pt-0 text-xs font-normal  text-gray-dark w-full leading-normal'>
                          {item.addressString && item.addressString !== ""
                            ? item.addressString
                            : "--"}
                          {item.pincode ? "- " + item.pincode : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className='flex justify-center w-full bg-yellow-2 duration-300 hover:bg-yellow-dark cursor-pointer py-2.5'
                    onClick={(event) => {
                      event.stopPropagation();
                      tagProperty(item._id);
                    }}>
                    <span className='text-sm font-medium'>Tag</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className='sm:block mt-3'>
        {totalRecords > 0 && (
          <Pagination
            pages={totalPages}
            currentPage={currentPageIndex}
            recordsPerPage={recordsPerPage}
            changePageCallback={changePageCallback}
            totalRecords={totalRecords}
            changeDisplayRecordCountCallback={changeDisplayRecordCountCallback}
          />
        )}
      </div>
    </div>
  );
};

export default PropertyTagging;
